import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SpeciesAdmin.css";

const SpeciesAdmin = () => {
  const [species, setSpecies] = useState([]);
  const [editingSpecies, setEditingSpecies] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchSpecies();
  }, []);

  const fetchSpecies = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/species`);
    setSpecies(res.data);
  };

  const handleEditClick = (speciesItem) => {
    setEditingSpecies(speciesItem.id);
    setFormData(speciesItem);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/species/${editingSpecies}`,
      formData
    );
    setEditingSpecies(null);
    fetchSpecies();
  };

  const renderForm = () => (
    <form className="speciesadmin-form">
      <div className="speciesadmin-form-group">
        <label>Name (EN):</label>
        <input
          type="text"
          name="name_en"
          value={formData.name_en}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Name (BN):</label>
        <input
          type="text"
          name="name_bn"
          value={formData.name_bn}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Family:</label>
        <input
          type="text"
          name="family"
          value={formData.family}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Published:</label>
        <input
          type="text"
          name="published"
          value={formData.published}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Synonym:</label>
        <input
          type="text"
          name="synonym"
          value={formData.synonym}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>IUCN:</label>
        <input
          type="text"
          name="iucn"
          value={formData.iucn}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Description:</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Phenology:</label>
        <textarea
          name="phenology"
          value={formData.phenology}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Adaptations:</label>
        <textarea
          name="adaptations"
          value={formData.adaptations}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Features:</label>
        <textarea
          name="features"
          value={formData.features}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Distribution:</label>
        <textarea
          name="distribution"
          value={formData.distribution}
          onChange={handleInputChange}
        />
      </div>
      <div className="speciesadmin-form-group">
        <label>Uses:</label>
        <textarea
          name="uses"
          value={formData.uses}
          onChange={handleInputChange}
        />
      </div>
      <button
        type="button"
        onClick={handleSave}
        className="speciesadmin-save-button"
      >
        Save
      </button>
    </form>
  );

  return (
    <div className="speciesadmin-container">
      <h1 className="speciesadmin-title">Species Administration</h1>
      {species.map((speciesItem) => (
        <div key={speciesItem.id} className="speciesadmin-card">
          <div className="speciesadmin-header">
            <h4>{speciesItem.name_en}</h4>
            <button
              onClick={() => handleEditClick(speciesItem)}
              className="speciesadmin-edit-button"
            >
              {editingSpecies === speciesItem.id ? "Cancel" : "Edit"}
            </button>
          </div>
          {editingSpecies === speciesItem.id && renderForm()}
        </div>
      ))}
    </div>
  );
};

export default SpeciesAdmin;
